<template>
  <simple-select :options="cityList" :value="value" @input="forwardEvent" />
</template>
<script>
import { SimpleSelect } from 'kanzler.components';

export default {
  props: {
    cities: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    cityList() {
      return this.cities
        .sort((a, b) => {
          return Number(a.sort) === Number(b.sort)
              ? a.name.localeCompare(b.name)
              : Number(a.sort) - Number(b.sort)
        })
        .reduce((keyValueObject, item) => {
          keyValueObject.set(item.id, item.name);
          return keyValueObject;
        }, new Map());
    }
  },
  components: {
    'simple-select': SimpleSelect
  },
  methods: {
    forwardEvent(value) {
      this.$emit('input', value);
    }
  }
}
</script>
